import { NgModule } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { PrivacyPolicyComponent } from "./privacy-policy.component";
import { PrivacyPolicyRoutingModule } from "./privacy-policy-routing";

@NgModule({
    declarations: [
        PrivacyPolicyComponent
    ],
    imports: [
        PrivacyPolicyRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
    ]
})
export class PrivacyPolicyModule {}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}